import React  from "react";
import { useParams } from 'react-router-dom';
import TimeCardForm from "./components/TimeCardDetails";

const EditHoliday = () => {

	const { cardId } = useParams();

	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
      		<TimeCardForm recordId={cardId} mode="edit"/>
	      </div>
	    </div>
    );
};

export default EditHoliday;